"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionForm = _interopRequireDefault(require("./actionForm.js"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _disabledMessage = _interopRequireDefault(require("./disabledMessage.js"));
var _redux = require("redux");
var _reduxForm = require("redux-form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Redux-form dependencies
var reducers = {
  form: _reduxForm.reducer
};
var reducer = (0, _redux.combineReducers)(reducers);
var store = (0, _redux.createStore)(reducer);
var Actions = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Actions, _React$Component);
  function Actions() {
    var _this;
    _classCallCheck(this, Actions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Actions, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: -1,
      isLoading: false,
      fields: []
    });
    _defineProperty(_assertThisInitialized(_this), "_submit", function (values) {
      var selectedAction = _this.props.actions[_this.state.selected];
      var _this$_getSubmitButto = _this._getSubmitButtonProps(),
        isConfirm = _this$_getSubmitButto.isConfirm,
        confirmationMessage = _this$_getSubmitButto.confirmationMessage;
      return new Promise(function (resolve, reject) {
        if (isConfirm) {
          (0, _cccisdConfirm["default"])(confirmationMessage).then(function () {
            resolve();
          }).fail(function () {
            reject();
          });
        } else {
          resolve();
        }
      }).then(function () {
        if (selectedAction.validateAsync) {
          return selectedAction.validateAsync(values);
        }
      }).then(function () {
        _this.setState({
          isLoading: true
        });

        // Run the action
        return selectedAction.action(_this.props.selectedRows, values, _this.props.callbacks);
      }).then(function () {
        _this.props.afterAction();
        _this.setState({
          selected: -1,
          isLoading: false,
          fields: []
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onChange", function (event) {
      var id = event.target.value * 1;
      _this.setState({
        selected: id,
        fields: []
      });
      if (id !== -1) {
        var selectedAction = _this.props.actions[id];
        if (selectedAction.getFields) {
          _this.setState({
            isLoading: true
          });

          // getFields can return data or Promise. It doesn't matter
          Promise.resolve(selectedAction.getFields()).then(function (fields) {
            _this.setState({
              fields: fields,
              isLoading: false
            });
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getSubmitButtonProps", function () {
      var selectedAction = _this.props.actions[_this.state.selected];

      // Title
      var badge = null;
      if (_this.props.selectedRows.length > 0) {
        badge = /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, _this.props.selectedRows.length);
      }
      var text = selectedAction && selectedAction.buttonText ? selectedAction.buttonText : 'Submit';
      var title = /*#__PURE__*/_react["default"].createElement("div", null, text, " ", badge);

      // Disabled status
      var isDisabled = selectedAction && _this.props.selectedRows.length > 0 ? false : true;

      // Is confirm?
      var isConfirm = selectedAction && selectedAction.isConfirm === false ? false : true;

      // Confirmation message
      var confirmationMessage = 'Are you sure?';
      if (selectedAction && selectedAction.getConfirmationMessage) {
        confirmationMessage = selectedAction.getConfirmationMessage(_this.props.selectedRows.length);
      }

      // Loading state
      var isLoading = _this.state.isLoading;
      return {
        title: title,
        isDisabled: isDisabled,
        isConfirm: isConfirm,
        confirmationMessage: confirmationMessage,
        isLoading: isLoading
      };
    });
    return _this;
  }
  _createClass(Actions, [{
    key: "render",
    value: function render() {
      if (this.props.actions.length === 0) {
        return null;
      }

      // Action options
      var actions = this.props.actions.map(function (action, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: index
        }, action.name);
      });
      actions.unshift( /*#__PURE__*/_react["default"].createElement("option", {
        key: "-1",
        value: "-1"
      }, "- Choose Action -"));
      var currentAction = this.props.actions[this.state.selected] || {};
      var fieldsArray = this.state.fields || [];
      var fields = fieldsArray.map(function (field) {
        return field.name;
      });
      var validate = currentAction.validate;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.wrapperClassName
      }, /*#__PURE__*/_react["default"].createElement("form", {
        className: "form-inline"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Actions for selected rows:"), ' ', /*#__PURE__*/_react["default"].createElement(_disabledMessage["default"], {
        number: this.props.disabledNumber,
        disabled: this.props.disabled
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control input-sm",
        id: "row_actions_select_box",
        value: this.state.selected,
        onChange: this._onChange,
        disabled: this.props.disabled
      }, actions))), ' ', /*#__PURE__*/_react["default"].createElement(_actionForm["default"], {
        store: store,
        fields: fields,
        validate: validate,
        onSubmit: this._submit,
        fieldsArray: fieldsArray,
        submitButtonProps: this._getSubmitButtonProps()
      })));
    }
  }]);
  return Actions;
}(_react["default"].Component);
_defineProperty(Actions, "propTypes", {
  actions: _propTypes["default"].array,
  selectedRows: _propTypes["default"].array,
  afterAction: _propTypes["default"].func,
  callbacks: _propTypes["default"].object,
  wrapperClassName: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  disabledNumber: _propTypes["default"].number
});